actions:
  refreshPage: Pagina verversen
  close: Sluiten
  cancel: Annuleren
  continue: Doorgaan
  newResource: Nieuw {resource}|Nieuwe {resource}
  appActivateResource: App activatiemail versturen
  accountActivateResource: Account activatiemail nogmaals versturen
  add: Aanmaken
  addResource: "{resource} aanmaken"
  resourceAdded: "{resource} aangemaakt"
  resourceSuccessfullyAdded: "{resource} succesvol aangemaakt"
  compose: Samenstellen
  composeResource: "{resource} samenstellen"
  resourceComposed: "{resource} samengesteld"
  delete: Verwijderen
  deleteResource: "{resource} verwijderen"
  resourceDeleted: "{resource} verwijderd"
  copy: "Kopiëren"
  copyResource: "{resource} kopiëren"
  resourceCopied: "{resource} gekopieerd"
  setBack: Terugzetten
  restore: Herstellen
  restoreResource: "{resource} herstellen"
  resourceRestored: "{resource} hersteld"
  change: Wijzigen
  edit: Bewerken
  editResource: "{resource} bewerken"
  resourceEdited: "{resource} bijgewerkt"
  download: Download
  downloadResource: "{resource} downloaden"
  resourceDownloaded: "{resource} ge-download"
  use: Gebruiken
  save: Opslaan
  saveResource: "{resource} opslaan"
  resourceSaved: "{resource} opgeslagen"
  confirm: Bevestigen
  next: Volgende
  previous: Vorige
  collapseText: Lees minder
  expandText: Lees meer
labels:
  copy: kopie
  item: Item|Items
  search: Zoeken
  yes: Ja
  no: Nee
  minutes: min|min
  hours: uur|uur
  summary: Samenvatting
  or: of
  days: dag|dagen
  year: jaar
  resourcesPerPage: "{resource} per pagina"
  fromToOfTotal: "{from}-{to} van {total}"
  createdAt: Toegevoegd op {date}
  closed: Gesloten
  max: "{count} max"
  perPerson: p.p.
  pageTitleAdmin: Admin
  pageTitleCentralWebsite: Aanmelden
  more: Meer
  at: om
  numberOfMaxPersons: "{count}/{max} deelnemers"
menuItems:
  myProfile: Mijn profiel
  admin: Instellingen
  centralAdmin: Admin
  tenantAdmin: Klantenoverzicht
  publicWebsite: Publieke pagina
  logout: Uitloggen
  customer: Klanten
  booking: Boeken
  calendar: Agenda
  salonized: Importeer Salonized klanten
  onboarding: Snel aan de slag
  user: Medewerkers
  treatment: Behandelingen
  companyDetails: Algemene info
  payment: Abonnement
enums:
  role:
    Admin: Beheerder
    Employee: Werknemer
  days:
    1: Maandag
    2: Dinsdag
    3: Woensdag
    4: Donderdag
    5: Vrijdag
    6: Zaterdag
    7: Zondag
  subscriptionPeriodType:
    Month: maand|maanden
    Week: week|weken
    Year: jaar|jaren
    Day: dag|dagen
messages:
  loading: Aan het laden...
  areYouSure: Weet je het zeker?
  actionCantBeReverted: Deze actie kan niet worden ongedaan gemaakt.
  backToList: Terug naar lijst
  noResults: Geen resultaten gevonden
  pressToAddPicture: Klik om een foto toe te voegen
  searchInTreatments: Zoek behandeling...
errors:
  default: Er ging iets mis, probeer het later opnieuw
  updateAvailable: Er is een update beschikbaar, refresh de pagina om door te gaan
auth:
  failed: Het e-mailadres of wachtwoord is onjuist
validation:
  required: Veld is verplicht
  unique: Veld heeft geen unieke waarde
  email:
    unique: E-mailadres al in gebruik
  slug:
    unique: Dit webadres is al in gebruik, kies een ander webadres
  type:
    string: Veld is verplicht
    email: Voer een geldig e-mailadres in
    valid_url: Voer een geldige URL in
    array: Voer een array in
    boolean: Voer ja of nee in
    date: Voer een geldige datum in
    file: Voer een bestand in
    image: Voer een afbeelding in
    integer: Voer een getal in
    ip: Voer een geldig ip adres in
    ipv4: Voer een geldig ipv4 adres in
    ipv6: Voer een geldig ipv6 adres in
    json: Voer een geldige json in
    numeric: Voer een getal in
    timezone: Voer een geldige timezone in
    uuid: Voer een geldige uuid in
    uploaded: Het is niet gelukt om het bestand te uploaden
    confirmed: Wachtwoorden komen niet overeen
    current_password: Het wachtwoord is onjuist
  date:
    incorrect: Onjuiste datum
    must_be_after: "Datum dient na {date} te zijn"
    must_be_after_or_equal: "Datum dient na of op {date} te zijn"
    must_be_after_or_equal,start date: "Datum dient na of op startdatum te zijn"
    must_be_after_or_equal,date: "Datum dient na of op andere datum te zijn"
    must_be_after_or_equal,today: "Datum dient na of op vandaag te zijn"
    must_be_before: "Datum dient vóór {date} te zijn"
    must_be_before_or_equal: "Datum dient vóór of op {date} te zijn"
    equal: "Datum dient {date} te zijn"
  only:
    letters: Invoer dient alleen letters te bevatten
    letters_numbers: Invoer dient alleen nummers te bevatten
  digits: Voer een getal in
  digits.between: Voer een getal tussen {from} en {to} in
  numeric:
    between: Voer een getal tussen {from} en {to} in
    greater_than: Invoer moet meer dan {value} zijn
    greater_than_equal: Invoer moet minstens {value} zijn
    less_than: Invoer moet minder dan {value} zijn
    less_than_equal: Invoer mag hoogstens {value} zijn
    max: Invoer mag hoogstens {value} zijn
    min: Invoer moet minstens {value} zijn
    no_negative: Invoer mag geen negatief getal zijn
  file:
    between: Voer een bestand tussen {from} KB en {to} KB in
    greater_than: Invoer moet meer dan {value} KB zijn
    greater_than_equal: Invoer moet minstens {value} KB zijn
    less_than: Invoer moet minder dan {value} KB zijn
    less_than_equal: Invoer mag hoogstens {value} KB zijn
    max: Invoer mag hoogstens {value} KB zijn
    min: Invoer moet minstens {value} KB zijn
    mimes: "Bestand moet één van de volgende extenties hebben: {extensions}"
  startsAfter:
    recursiveLoop: Stappen kunnen niet naar elkaar verwijzen
  string:
    between: Voer een waarde tussen {from} en {to} karakters in
    greater_than: Invoer moet meer dan {value} karakters zijn
    greater_than_equal: Invoer moet minstens {value} karakters zijn
    less_than: Invoer moet minder dan {value} karakters zijn
    less_than_equal: Invoer mag hoogstens {value} karakters zijn
    max: Invoer mag hoogstens {value} karakters zijn
    min: Invoer moet minstens {value} karakters zijn
    symbols: Gebruik minstens één symbool
  password:
    uncompromised: Je gekozen wachtwoord is voorgekomen in een datalek, kies een ander wachtwoord.
  flow:
    end_date:
      before_flow_start_date: Einddatum mag niet voor start boarding liggen
      before_minimal_date: Einddatum kan niet vóór de laatste geplande stap liggen
  checkin:
    unique_name: Er bestaat al een check-in met deze titel
  invalid,slug: Gebruik alleen kleine letters, cijfers en streepjes
